import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UserPromptService } from '../services/user-prompt.service';
import { FormsModule } from '@angular/forms';
import { SaveSuccessComponent } from '../save-success/save-success.component';
import { ButtonComponent } from '../components/common/components/button/button.component';
import { DashboardService } from '../services/shared/dashboard.service';
import { TimePickerComponent } from '../components/common/time-picker/time-picker.component';

@Component({
  selector: 'app-rating-feedback',
  standalone: true,
  imports: [MatDialogModule,CommonModule,FormsModule, ButtonComponent,TimePickerComponent],
  templateUrl: './rating-feedback.component.html',
  styleUrl: './rating-feedback.component.scss'
})
export class RatingFeedbackComponent {
  message: string = ""
  actionType: string="add"
  cancelButtonText = "Cancel"
  selectedrating: number = -1 ;
  hoveredRating: number = -1 ;
  RationalIndex: number = -1 ;
  remindMeLaterCount=0;
  isSubmitDisabled:boolean = false;
  isCommentRequired:boolean = false;
  remind_me_later_count:number=0;
  timeSaved:any=180;
  isTimeRequired:boolean=false;
  isRateRequired:boolean=false;
  comments: string ='';
  userid: any;
  user_role: any;
  prompt_id: any;
  view:number=0;
  starHover: boolean = false;
  ratingRationalData = [
    'Output was unusable, significantly slower and lower quality than my usual manual process.',
    'Output required extensive edits, less efficient than my manual approach, minimal usefulness.',
    'Output efficiency matched my manual approach; partly useful but required significant improvements.',
    'Output provided good efficiency gains; useful first draft needing moderate editing.',
    'Output significantly improved efficiency; high-quality draft with only minor refinements needed.'
  ];
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<RatingFeedbackComponent>,private userPromptService: UserPromptService,private dialog:MatDialog, private dashboardService: DashboardService) {
    if (data) {
      this.message = data.message || this.message;
      this.actionType = data.action_type
      this.prompt_id=data.prompt_id_val;
      this.selectedrating = data.rating - 1;
      this.RationalIndex = data.rating - 1;
      this.remind_me_later_count=data?.remind_me_later_count ? data?.remind_me_later_count:0;
      this.comments=data?.prompt_details?.comments;
 
      if(this.remind_me_later_count>2  && this.selectedrating == -1){
        this.isRateRequired=true;
      }
      //this.timeSaved=data?.prompt_details?.time_saved ? data?.prompt_details?.time_saved:0;
      //this.selectedrating=data.rating;
      this.view=data?.prompt_details?.total_views;
    }
    //this.dialogRef.updateSize('300vw','300vw')
    this.checkComments();
  }
  selectedHour: number | null=3;
  customSelected:boolean=false;

  hourOptions = [
    { value: 1, label: '1 hour' },
    { value: 3, label: '3 hours' },
    { value: 5, label: '5 hours' },
    { value: 7, label: '7 hours' },
    { value: null, label: 'Custom' },
  ];

  add(value: number | null , label: string) {
    this.selectedHour = value;

    if (value !== null) {
      this.customSelected=false;
      // Your add logic here
      this.hours=value;

      // this.timeSaved=((this.selectedHour ?? 0) * 60);
   
    } else {
     
      this.customSelected=true;
      // this.selectedHour=2;
      // this.timeSaved=((this.selectedHour ?? 0) * 60);
      
    }
  }

  hours: number = 3;

  increment() {
    this.hours++;
    // this.selectedHour=this.hours;
    // this.timeSaved=((this.selectedHour ?? 0) * 60);
    // this.receiveTime(this.timeSaved);
  }
  add1(n:number){
    this.hours=n;

  }

  submit(hours:number){
   

  }

  decrement() {
    if (this.hours > 0) this.hours--;
    
  }

  // onInput(event: Event) {
  //   const input = (event.target as HTMLInputElement).value;
  //   this.hours = parseFloat(input) || 0;
  //   this.selectedHour=this.hours;
  //   this.timeSaved=((this.selectedHour ?? 0) * 60);
  //   this.receiveTime(this.timeSaved);
  // }
  
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
  
    // Regular expression to match numbers with up to two decimal places
    const regex = /^\d+(\.\d{0,2})?$/;
  
    if (regex.test(value)) {
      this.hours = parseFloat(value);
    } else {
      // If input doesn't match, revert to the previous valid value
      input.value = this.hours.toFixed(2);
    }

 
  }

  ngOnInit() {
    this.user_role = this.dashboardService.user_role
    this.userid = this.dashboardService.user_id;
    let remindMeLaterCount = localStorage.getItem('remindMeLaterCount');
    let obj:any;
    if(this.timeSaved>0){
      this.isTimeRequired=false;
    }
    if (remindMeLaterCount) {
      // Parse stored string into an object
      obj = JSON.parse(remindMeLaterCount);
      obj.count = (obj.count || 0) ; // Increment count safely
      this.remindMeLaterCount=this.data?.prompt_details?.prompt_id == obj.id ? obj.count :0;
    }
    // if(this.data?.prompt_details?.prompt_id != obj.id)
    // {
    //   localStorage.setItem('remindMeLaterCount', JSON.stringify({
    //     id: this.data?.prompt_details?.prompt_id,
    //     count: 0
    //   }));
    // }
  }


  receiveTime(data: string) {
    this.timeSaved = data; // Receive and store data from child
    
    if(this.timeSaved == 0 || this.timeSaved>0 ){
      this.isTimeRequired=false;
    }
  }


  checkComments() {
    // if(!this.comments && this.selectedrating<3) {
    //   this.isSubmitDisabled=true;
    //   this.isCommentRequired=true;
    //   return;
    // };
    // Splitting the text into words and filtering out empty spaces
    if((this.comments == null) || (this.comments.trim() == "" && this.selectedrating == -1)) return;

    if((this.comments.trim() == "") && (this.selectedrating > -1 && this.selectedrating<3)) {
      this.isSubmitDisabled=true;
      this.isCommentRequired=true;
      return;
    };

    const wordCount = this.comments.trim().split(/\s+/).filter(word => word.length > 0).length;
    this.isCommentRequired=(wordCount<1 && ( this.selectedrating>-1 && this.selectedrating<3));
    // Enable the button only if there are more than 3 words
    // this.isSubmitDisabled =  (this.selectedrating ==-1  ||  wordCount < 1);
    if(this.selectedrating == -1 && wordCount<1){
      this.isSubmitDisabled=false;
    }else if( this.selectedrating>-1 && this.selectedrating<3 && wordCount<1){
      this.isSubmitDisabled=true;
    }else{
      this.isSubmitDisabled=false;
    }
  }

  onConfirmClick(event: any): void {
    //this.dialogRef.close({showMsg: false});
    if(this.remind_me_later_count == 3 && this.data?.prompt_details?.my_rating==0){
      return;
    }
    if(this.timeSaved == ""){
    this.isTimeRequired=true;
    return;
    }

    let remindMeLaterCount = localStorage.getItem('remindMeLaterCount');

    if (remindMeLaterCount) {
      let obj = JSON.parse(remindMeLaterCount); // Parse stored string into an object
      obj.count = (obj.count || 0) + 1; // Increment count safely
      this.remindMeLaterCount=obj.count;
      localStorage.setItem('remindMeLaterCount', JSON.stringify(obj)); // Save updated object
    } else {
      localStorage.setItem('remindMeLaterCount', JSON.stringify({
        id: this.data?.prompt_details?.prompt_id,
        count: 1
      }));
    }
  

    let request={
      "prompt_id": this.prompt_id,
      "user_id": +this.userid,
      "rating": this.selectedrating + 1,
      "comments": this.comments,
      "remind_me_later_count":this.remind_me_later_count+1,
      "time_saved":Math.round(this.timeSaved),
    }
    
    if(request){
    
      this.userPromptService.addToFeedback(request)
      .subscribe( (res)=>{
        if(res.status_code === 200){
       
          //this.remind_me_later_count= res.remind_me_later_count
          // const dialogRef = this.dialog.open(SaveSuccessComponent,{
          //   data:{
          //     message:this.message,
          //     title:"Saved successfully",
          //     actionType: 'save',
          //     modalName: 'rating'
          //   }
          // });
        
          
         this.dialogRef.close({showMsg: true, rating: request.rating,remind_me_later_count:request.remind_me_later_count,time_saved:res?.data?.time_saved});
        }
      });
    }
    //this.onLaterClick();
  }

  onLaterClick(): void {
   
    this.dialogRef.close({ clickedLater: true }); // Send info to parent
  }

  handleRationalEnter(id: number) {
    this.starHover = true;
    this.hoveredRating = id;
    this.RationalIndex = id;
  }
  handleRationalLeave(id: number) {
    this.starHover = false;
    this.hoveredRating = 0;
    this.RationalIndex = this.selectedrating;
  }
  selectRate(idx:number){
    
    if(this.data?.rating>1){//means it already have some rating.
    this.selectedrating = idx;
    this.RationalIndex = idx;
    }else{
    this.selectedrating=this.selectedrating === idx ? -1 : idx;
    }

   
    if(idx<3){
      if((this.selectedrating != -1 && this.selectedrating<3) && this.comments == null) {
        this.isSubmitDisabled=true;
        this.isCommentRequired = true;
      }else if(this.selectedrating != -1 && this.comments.trim() == ""){
        this.isSubmitDisabled=true;
        this.isCommentRequired = true;
      } else{
        this.isSubmitDisabled=false;  
        this.isCommentRequired = false;
      }
    }else{
      this.isCommentRequired = false;
      this.isSubmitDisabled = false;
    }
    if(this.selectedrating != -1){
        this.isRateRequired=false;
    }else if(this.remind_me_later_count>2  && this.selectedrating == -1){
      this.isRateRequired=true;
    }
  }

  onSubmit(event: any){

    this.selectedHour=this.hours;
    this.timeSaved=((this.selectedHour ?? 0) * 60);
    this.receiveTime(this.timeSaved);
    if(this.timeSaved === "" ){
      
      //this.timeSaved=0;
      this.isTimeRequired=true;
      return;
      }
    if(this.isRateRequired){ // is rating required
      return;
    }
      
      let request:any={}
    if(this.data?.rating>1 || this.selectedrating >0 || this.selectedrating == 0){
      request ={
        "prompt_id": this.prompt_id,
        "user_id": +this.userid,
        "rating": this.selectedrating + 1,
        "comments": this.comments,
        "remind_me_later_count":this.remind_me_later_count,
        "time_saved":Math.round(this.timeSaved),
      }
      
    }else{
      request ={
        "prompt_id": this.prompt_id,
        "user_id": +this.userid,
        "rating": null,
        "comments": null,
        "remind_me_later_count":this.remind_me_later_count,
        "time_saved":Math.round(this.timeSaved),
      }
    }  
    
    let isValidRequest =true;
    if((this.selectedrating> -1 && this.selectedrating  < 2) && ( this.comments == null || this.comments.length == 0)){
      isValidRequest = false;
    }else{
      isValidRequest = true
    }
    if(isValidRequest){
      
      this.userPromptService.addToFeedback(request).subscribe(res=>{
        let timeonly=true;
        if(request?.rating != null){
              timeonly=false;                
        }
        if(res.status_code === 200){
       
          const dialogRef = this.dialog.open(SaveSuccessComponent,{
            data:{
              message:this.message,
              title:"Saved successfully",
              actionType: 'save',
              modalName: 'rating',
              timeOnly:timeonly
              
            }
          });
        
          
          this.dialogRef.close({showMsg: true, rating: request.rating,remind_me_later_count:res?.remind_me_later_count,time_saved:res?.data?.time_saved,comments:res?.data?.comments});
        }
      });
    }
   

  }

  convertMinutesToHours(minutes: number): string {
    if (minutes <= 0) return ""; // Handle negative values

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    return `${hours} hour${hours !== 1 ? 's' : ''} ${remainingMinutes} minute${remainingMinutes !== 1 ? 's' : ''}`;
}
}
